import type dayjs from 'dayjs';
import type { ActorRef, ActorRefFrom, Snapshot } from 'xstate';
import { enqueueActions, fromPromise, setup } from 'xstate';

import type { InfoModel } from '@webapp/common/resources/entities/info';

import { bootstrap } from './actions';

enum BootstrapState {
    INITIAL = 'INITIAL',
    RUNNING = 'RUNNING',
    SUCCESS = 'SUCCESS',
    FAIL = 'FAIL',
}
type ChildEvents = { type: 'SET_INFO'; info: InfoModel };
type ParentActor = ActorRef<Snapshot<unknown>, ChildEvents>;
type BootstrapEvents = { type: 'START'; domain: string; token: string; update?: boolean; individualTries: number };
export const bootstrapMachine = setup({
    types: {
        input: {} as { parentRef: ParentActor },
        context: {} as { parentRef: ParentActor },
        events: {} as BootstrapEvents,
    },
    actors: {
        bootstrapInvoke: fromPromise<
            {
                code: number;
                token: string;
                startDatetime: dayjs.Dayjs;
                info: InfoModel | null;
                agreementText: string | null;
                qp: Record<string, string>;
            },
            { domain: string; token: string; update?: boolean; individualTries: number }
        >(async ({ input }) => {
            const data = input;
            const resp = await bootstrap(data);

            return resp;
        }),
    },
}).createMachine({
    id: 'BootstrapMachine',
    initial: BootstrapState.INITIAL,
    context: ({ input }) => input,
    states: {
        [BootstrapState.INITIAL]: {
            on: {
                START: {
                    target: BootstrapState.RUNNING,
                },
            },
        },
        [BootstrapState.RUNNING]: {
            invoke: {
                id: 'bootstrap',
                src: 'bootstrapInvoke',
                input: ({ event }) => ({ ...event }),
                onDone: {
                    target: BootstrapState.SUCCESS,
                    actions: enqueueActions(({ event, enqueue }) => {
                        enqueue.sendTo(({ context }) => context.parentRef, {
                            type: 'SET_INFO',
                            info: event.output.info,
                        });
                    }),
                },
                onError: {
                    target: BootstrapState.FAIL,
                },
            },
        },
        [BootstrapState.SUCCESS]: {
            on: {
                START: {
                    target: BootstrapState.RUNNING,
                },
            },
        },
        [BootstrapState.FAIL]: {
            on: {
                START: {
                    target: BootstrapState.RUNNING,
                },
            },
        },
    },
});
export type BootstrapMachineActor = ActorRefFrom<typeof bootstrapMachine>;
